import { styledTheme } from 'Themes/default';
import { ThemeProvider } from 'styled-components';
import injectGlobal from 'Themes/globalStyles';
import Layout from 'Components/Layout';
// import LogRocket from 'logrocket';
import React, { Component } from 'react';
import typography from 'Themes/typography';

// import Supply from '../../Supply';
import Supply from '../../Supply';

class Main extends Component {
  componentDidMount() {
    injectGlobal();
    typography.injectStyles();
    // if (process.env.NODE_ENV === 'production') {
    //   LogRocket.init('ee6ffi/arup');
    // }
  }

  // componentWillUnmount() {
  //   const style = document.querySelector('#typography\\.js');
  //   style.parentNode.removeChild(style);
  // }

  render() {
    const { role } = this.props;
    return (
      <ThemeProvider theme={styledTheme}>
        <Layout role={role}>
          <Supply {...this.props} />
        </Layout>
      </ThemeProvider>
    );
  }
}

export default Main;
